import { render, staticRenderFns } from "./crear_simple.vue?vue&type=template&id=1059fae1&scoped=true&"
import script from "./crear_simple.vue?vue&type=script&lang=ts&"
export * from "./crear_simple.vue?vue&type=script&lang=ts&"
import style0 from "./crear_simple.vue?vue&type=style&index=0&id=1059fae1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1059fae1",
  null
  
)

export default component.exports